module.exports = __webpack_public_path__ + "img/jjhlogo.7fe51679.png";